// Top currencies to display by default
export const TOP_CURRENCIES = ['USD', 'EUR', 'GBP', 'JPY', 'AUD', 'CAD', 'IRR'];

// Currency to country mapping
export const CURRENCY_TO_COUNTRY: { [key: string]: { name: string; flag: string } } = {
    USD: { name: 'United States', flag: '🇺🇸' },
    EUR: { name: 'European Union', flag: '🇪🇺' },
    GBP: { name: 'United Kingdom', flag: '🇬🇧' },
    JPY: { name: 'Japan', flag: '🇯🇵' },
    AUD: { name: 'Australia', flag: '🇦🇺' },
    CAD: { name: 'Canada', flag: '🇨🇦' },
    IRR: { name: 'Iran', flag: '🇮🇷' },
    CHF: { name: 'Switzerland', flag: '🇨🇭' },
    CNY: { name: 'China', flag: '🇨🇳' },
    INR: { name: 'India', flag: '🇮🇳' },
    BRL: { name: 'Brazil', flag: '🇧🇷' },
    RUB: { name: 'Russia', flag: '🇷🇺' },
    ZAR: { name: 'South Africa', flag: '🇿🇦' },
    MXN: { name: 'Mexico', flag: '🇲🇽' },
    SGD: { name: 'Singapore', flag: '🇸🇬' },
    HKD: { name: 'Hong Kong', flag: '🇭🇰' },
    TRY: { name: 'Turkey', flag: '🇹🇷' },
    KRW: { name: 'South Korea', flag: '🇰🇷' },
    SEK: { name: 'Sweden', flag: '🇸🇪' },
    NOK: { name: 'Norway', flag: '🇳🇴' },
    NZD: { name: 'New Zealand', flag: '🇳🇿' }
};

// Country to currency mapping
export const COUNTRY_TO_CURRENCY: { [key: string]: string } = {
    US: 'USD',
    EU: 'EUR',
    GB: 'GBP',
    JP: 'JPY',
    AU: 'AUD',
    CA: 'CAD',
    IR: 'IRR',
    CH: 'CHF',
    CN: 'CNY',
    IN: 'INR',
    BR: 'BRL',
    RU: 'RUB',
    ZA: 'ZAR',
    MX: 'MXN',
    SG: 'SGD',
    HK: 'HKD',
    TR: 'TRY',
    KR: 'KRW',
    SE: 'SEK',
    NO: 'NOK',
    NZ: 'NZD'
};

// Refresh interval in milliseconds (5 minutes)
export const REFRESH_INTERVAL = 5 * 60 * 1000;

// Rate sources configuration
export const RATE_SOURCES = {
    MESGHAL: {
        name: 'Mesghal',
        url: 'https://mesghal.com',
        enabled: true,
        priority: 1
    },
    EXCHANGE_RATE_API: {
        name: 'Exchange Rate API',
        url: 'https://v6.exchangerate-api.com',
        enabled: true,
        priority: 2
    }
};

// Toman to Rial conversion factor
export const TOMAN_TO_RIAL_FACTOR = 10; 